// Applique la paire de polices de la boutique (Studio de thème) en custom
// properties CSS sur :root — tailwind.config.js et App.css lisent ces mêmes
// variables (--font-heading, --font-body) avec un repli identique au rendu
// d'origine (Space Grotesk partout) tant qu'elles ne sont pas définies.

// Familles déjà demandées par les feuilles de style Google Fonts présentes
// dans le document — celle d'index.html comprise.
function loadedFamilies() {
  const families = new Set();
  document.head.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
    const href = link.getAttribute("href") || "";
    if (!href.includes("fonts.googleapis.com")) return;
    try {
      new URLSearchParams(href.split("?")[1] || "")
        .getAll("family")
        .forEach((f) => families.add(f.split(":")[0]));
    } catch {
      /* href illisible : on ignore, quitte à recharger la police */
    }
  });
  return families;
}

export function ensureGoogleFontLink(googleQuery) {
  if (!googleQuery) return;
  const href = `https://fonts.googleapis.com/css2?${googleQuery}&display=swap`;
  if (document.head.querySelector(`link[href="${href}"]`)) return;

  // Une SECONDE requête bloquante vers Google était émise même quand la
  // boutique utilise la paire par défaut, déjà déclarée dans index.html :
  // les deux URL diffèrent (celle d'index.html ajoute JetBrains Mono), donc
  // la comparaison d'href ci-dessus ne la détectait pas. On compare
  // désormais les FAMILLES demandées, et on n'ajoute le lien que si l'une
  // d'elles manque réellement — cas d'une paire personnalisée.
  const already = loadedFamilies();
  let requested = [];
  try {
    requested = new URLSearchParams(googleQuery).getAll("family").map((f) => f.split(":")[0]);
  } catch {
    requested = [];
  }
  if (requested.length && requested.every((f) => already.has(f))) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

export default function applyTypography(typography) {
  if (!typography) return;
  ensureGoogleFontLink(typography.google_query);
  const root = document.documentElement;
  if (typography.heading) root.style.setProperty("--font-heading", typography.heading);
  if (typography.body) root.style.setProperty("--font-body", typography.body);
}
